import {
  CModal,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useState } from "react";
import InfoIcon from "../../components/icons/InfoIcon";
import NotificationNotSentIcon from "../../components/icons/NotificationNotSentIcon";
import NotificationSentIcon from "../../components/icons/NotificationSentIcon";
import PendingIcon from "../../components/icons/PendingIcon";
import { tdStyle, thStyle } from "../../helpers/constants";
import { IconAction } from "../../helpers/general";
import NotificationViewModel from "./NotificationViewModel";

export function NotificationStatus({
  sent,
  date,
}: {
  sent: boolean;
  date: string;
}) {
  if (sent === true) {
    return (
      <div>
        <NotificationSentIcon className="fill-success" /> Envoyé
      </div>
    );
  }
  const diff = new Date(date).getTime() - Date.now();
  if (diff > 0) {
    return (
      <div>
        <PendingIcon className="fill-danger" /> En attente
      </div>
    );
  }
  return (
    <div>
      <NotificationNotSentIcon className="fill-red" /> Pas envoyé
    </div>
  );
}

interface TableProps {
  notifications: ScheduledNotification[];
}

export default function NotificationsTable({ notifications }: TableProps) {
  const [selected, setSelected] = useState<ScheduledNotification | null>(null);

  return (
    <>
      <CTable responsive hover align="middle" className="mb-0">
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell style={thStyle}>Titre</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Date</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Statut</CTableHeaderCell>
            <CTableHeaderCell style={{ ...thStyle, textAlign: "right" }}>
              Actions
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {notifications?.map((notification) => (
            <CTableRow key={notification?.id}>
              <CTableDataCell style={tdStyle}>
                <span className="fw-semibold">{notification?.title}</span>
              </CTableDataCell>

              <CTableDataCell style={tdStyle} className="text-capitalize">
                {new Date(notification.date).toLocaleDateString("fr", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </CTableDataCell>

              <CTableDataCell style={tdStyle} className="text-capitalize">
                <NotificationStatus
                  sent={notification?.sent}
                  date={notification.date}
                />
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                <div className="d-flex align-items-center justify-content-end gap-2">
                  <IconAction
                    title="Voir les détails"
                    onClick={() => setSelected(notification)}
                  >
                    <InfoIcon className="fill-primary" />
                  </IconAction>
                </div>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>

      {/* One details modal for the whole table */}
      <CModal
        visible={selected !== null}
        onClose={() => setSelected(null)}
        alignment="center"
      >
        {selected && (
          <NotificationViewModel
            notification={selected}
            onClose={() => setSelected(null)}
          />
        )}
      </CModal>
    </>
  );
}
